<template>
  <v-card class="mb-4" v-bind="cardAttrs">
    <v-card-title v-if="selectable" class="d-flex align-center">
      <span class="text-truncate">{{ label }}</span>
      <v-tooltip :text="tooltip" location="top" v-if="tooltip && tooltip.length > 0">
        <template v-slot:activator="{ props }">
          <v-icon
            v-bind="props"
            icon="mdi-information"
            size="small"
            class="ml-2"
          ></v-icon>
        </template>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-icon v-if="active" icon="mdi-filter" size="small" color="primary"></v-icon>
    </v-card-title>
    <v-card-title v-else>
      {{ label }}
      <v-tooltip :text="tooltip" location="top" v-if="tooltip && tooltip.length > 0">
        <template v-slot:activator="{ props }">
          <v-icon
            v-bind="props"
            icon="mdi-information"
            size="small"
            class="ml-2"
          ></v-icon>
        </template>
      </v-tooltip>
    </v-card-title>
    <v-card-text class="text-h3" v-bind="valueAttrs">
      {{ displayValue }}
    </v-card-text>
  </v-card>
</template>

<script src="./model.js"></script>
<style src="./style.css"></style>
